import React, { useState } from 'react';
import { Bell, Plus, Trash2, CheckCircle } from 'lucide-react';

const AlertsView = ({ t, lang }) => {
  const [alerts, setAlerts] = useState([
    { id: 1, ticker: 'NVDA', type: 'price_above', value: 500, enabled: true },
    { id: 2, ticker: 'BTC', type: 'price_below', value: 40000, enabled: true }
  ]);
  const [showAdd, setShowAdd] = useState(false);
  const [newAlert, setNewAlert] = useState({ ticker: '', type: 'price_above', value: '' });

  const toggleAlert = (id) => {
    setAlerts(alerts.map(a => a.id === id ? { ...a, enabled: !a.enabled } : a));
  };

  const deleteAlert = (id) => {
    setAlerts(alerts.filter(a => a.id !== id));
  };

  const addAlert = () => {
    if (newAlert.ticker && newAlert.value) {
      setAlerts([...alerts, { ...newAlert, id: Date.now(), enabled: true, value: parseFloat(newAlert.value) }]);
      setNewAlert({ ticker: '', type: 'price_above', value: '' });
      setShowAdd(false);
    }
  };

  const alertTypes = {
    price_above: lang === 'fr' ? 'Prix au-dessus de' : 'Price above',
    price_below: lang === 'fr' ? 'Prix en-dessous de' : 'Price below',
    new_reco: lang === 'fr' ? 'Nouvelle recommandation' : 'New recommendation'
  };

  return (
    <div className="history-card">
      <div className="history-header">
        <span className="history-title">{t.app.alerts}</span>
        <button className="btn btn-primary btn-sm" onClick={() => setShowAdd(!showAdd)}>
          <Plus size={14} /> {lang === 'fr' ? 'Nouvelle alerte' : 'New alert'}
        </button>
      </div>
      
      {showAdd && (
        <div style={{ padding: '24px', borderBottom: '1px solid var(--border-color)', background: 'var(--bg-tertiary)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: '12px', alignItems: 'end' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '6px' }}>
                {lang === 'fr' ? 'Actif' : 'Asset'}
              </label>
              <input 
                type="text" 
                placeholder="NVDA, BTC..." 
                value={newAlert.ticker}
                onChange={(e) => setNewAlert({ ...newAlert, ticker: e.target.value.toUpperCase() })}
                style={{ 
                  width: '100%', padding: '10px 12px', background: 'var(--bg-secondary)', 
                  border: '1px solid var(--border-color)', borderRadius: '8px', color: 'var(--text-primary)'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '6px' }}>
                Type
              </label>
              <select 
                value={newAlert.type}
                onChange={(e) => setNewAlert({ ...newAlert, type: e.target.value })}
                style={{ 
                  width: '100%', padding: '10px 12px', background: 'var(--bg-secondary)', 
                  border: '1px solid var(--border-color)', borderRadius: '8px', color: 'var(--text-primary)'
                }}
              >
                {Object.entries(alertTypes).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '6px' }}>
                {lang === 'fr' ? 'Valeur' : 'Value'}
              </label>
              <input 
                type="number" 
                placeholder="500" 
                value={newAlert.value}
                onChange={(e) => setNewAlert({ ...newAlert, value: e.target.value })}
                style={{ 
                  width: '100%', padding: '10px 12px', background: 'var(--bg-secondary)', 
                  border: '1px solid var(--border-color)', borderRadius: '8px', color: 'var(--text-primary)'
                }}
              />
            </div>
            <button className="btn btn-primary btn-sm" onClick={addAlert} style={{ height: '42px' }}>
              <CheckCircle size={14} />
            </button>
          </div>
        </div>
      )}

      {alerts.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: 'var(--text-tertiary)' }}>
          <Bell size={48} style={{ marginBottom: 16, opacity: 0.3 }} />
          <p>{lang === 'fr' ? 'Aucune alerte configurée' : 'No alerts configured'}</p>
        </div>
      ) : (
        <table className="history-table">
          <thead>
            <tr>
              <th>Actif</th>
              <th>Type</th>
              <th>{lang === 'fr' ? 'Valeur' : 'Value'}</th>
              <th>{lang === 'fr' ? 'Statut' : 'Status'}</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {alerts.map(a => (
              <tr key={a.id}>
                <td><strong>{a.ticker}</strong></td>
                <td>{alertTypes[a.type]}</td>
                <td className="font-mono">${a.value?.toLocaleString()}</td>
                <td>
                  <span 
                    className={`result-badge ${a.enabled ? 'win' : 'loss'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleAlert(a.id)}
                  >
                    {a.enabled ? (lang === 'fr' ? 'Actif' : 'Active') : (lang === 'fr' ? 'Désactivé' : 'Disabled')}
                  </span>
                </td>
                <td>
                  <button 
                    className="btn btn-ghost btn-sm" 
                    onClick={() => deleteAlert(a.id)}
                    style={{ color: 'var(--color-danger)' }}
                  >
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AlertsView;
